import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useLayoutEffect, useState } from 'react';
import { allocateTechnicianBeacon, fetchUnallocatedBeacons } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import TechniciansBeaconListing from './TechniciansBeaconListing';
import { Label } from '@radix-ui/react-dropdown-menu';
import { Technicians } from './TechniciansColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showAddBeaconToTechnicianDrawer: boolean;
    setShowAddBeaconToTechnicianDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    technicians: Technicians
    setTechnicianData: React.Dispatch<React.SetStateAction<Technicians | undefined>>;
}
const AddBeaconToTechnicianDrawer: React.FC<ProductsDrawerProps> = ({ showAddBeaconToTechnicianDrawer, setShowAddBeaconToTechnicianDrawer, technicians, setTechnicianData }) => {
    const onCLose = () => {
        setTechnicianData(undefined)
        setShowAddBeaconToTechnicianDrawer(false)
    }
    const [submitting, setSubmitting] = useState(false)
    const [searchTermForunallocatedBeacon, setSearchTermForunallocatedBeacon] = useState('')
    const [unallocatedBeaconsToDisplay, setUnallocatedBeaconsToDisplay] = useState([])
    const [unallocatedBeaconsOptions, setUnallocatedBeaconsOptions] = useState([])
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()


    useLayoutEffect(() => {
        const setFormValues = async () => {
            form.setFieldsValue({
                id: technicians.beacon_store_id,
                

            })
        };
        if (technicians) {
            setFormValues()
        }
    }, [technicians, form])



    const getUnallocatedBeacons = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beacons/unallocatedBeacons`, {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setUnallocatedBeaconsToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useLayoutEffect(() => {
        getUnallocatedBeacons()
    }, [])


    const onFinish = (payload: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.post('/api/v1/beacons/allocateBeaconTechnician', payload, {
            signal: controller.signal
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "beacons successfully assigned",
                    `${technicians.first_name} ${technicians.last_name} was assigned beacons`,
                    'topRight'
                )
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        const updatedunallocatedBeaconsOptions: any = unallocatedBeaconsToDisplay.map((customer: any) => ({
            label: customer.cid,
            value: customer.id
        }));
        setUnallocatedBeaconsOptions(updatedunallocatedBeaconsOptions);
    }, [unallocatedBeaconsToDisplay])

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }

    const handleCustomerChange = (value: any) => {
        setSearchTermForunallocatedBeacon(value)
    }

    const filterBeaconsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }


    return (
        <>

            <Drawer
                title={`Add Beacons to ${technicians.first_name} ${technicians.last_name}`}
                width={720}
                onClose={onCLose}
                open={showAddBeaconToTechnicianDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical"
                    onFinishFailed={onFinishFailed}
                    onFinish={onFinish}
                    initialValues={{
                        id: technicians.beacon_store_id
                    }}
                    form={form}
                    hideRequiredMark>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="selectedBeaconIds"
                                label="Beacon cid"
                                rules={[{ required: true, message: 'Please slect customer name' }]}
                            >
                                <Select
                                    placeholder="Please select customer name"
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    style={{ borderColor: 'black' }}
                                    onSearch={handleCustomerChange}
                                    filterOption={filterBeaconsOptions}
                                >
                                    {unallocatedBeaconsOptions.map((option: any) => (
                                        <Option key={option.value} value={option.value}>{option.label}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Label>{`${technicians.first_name} ${technicians.last_name}'s beacons`}</Label>
                            <TechniciansBeaconListing beacon_store_id={technicians.beacon_store_id} />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item
                        name="id"
                        label="id"
                        rules={[{ required: true, message: 'Please enter name' }]}
                        hidden={true}
                    >
                        <Input
                            placeholder="Please enter name"
                            className='focus:border-green-500 hover:border-green-500'
                        />
                    </Form.Item>
                    <Row>

                        {submitting && <Spin indicator={antIcon} />}
                    </Row>


                </Form>
            </Drawer>
        </>
    )
}

export default AddBeaconToTechnicianDrawer;


